import { createI18n } from "vue-i18n";

// 预加载基础语言包
const messages = {
  en: {},
  "zh-cn": {},
  "zh-tw": {},
  de: {},
  es: {},
  fr: {},
};

export const i18n = createI18n({
  legacy: false,
  locale: systemStorage.value.lang || "en",
  fallbackLocale: "en",
  messages,
  missingWarn: false, // 禁用翻译缺失警告
  fallbackWarn: false, // 禁用回退警告
});

export default i18n;
